import React from 'react'
import ImageHeader from '../../component/ImageHeader'
import ContactHead from '../Contact/ContactHead';
import CuisineStart from '../cuisine/CuisineStart';
import CuisineTreat from '../cuisine/CuisineTreat';
import CuisineFresh from '../cuisine/CuisineFresh';

const imageHead = {
  title: 'Nourishing Flavours by the Ganges',
  image: "../image/rishikesh-cuisine-banner.webp",
  breadcrumb: [
    {
      slug: "/resort-de-coracao-rishikesh",
      name: "Rishikesh",
    },
    {
      name: "Dining",
    },
  ]
}

const quoteHead = {
  desc: "Surrounded by the calm of the Ganges and the spiritual rhythm of the town, every meal at De Coracao, Rishikesh, is designed to nourish both body and mind. From fresh, locally sourced ingredients to thoughtfully prepared dishes, the focus is on simplicity, purity, and authentic taste. Whether you begin your day with a wholesome breakfast or wind down with a comforting dinner, our cuisine reflects the essence of Rishikesh: clean, balanced, and soulful. Expect a mix of regional Indian flavours, sattvic-inspired meals, and familiar favourites, all prepared with care and served with warmth.",
  title: "An Overview",
};

const startData = {
  title: "A Fresh Start: Our Riverside Breakfast ",
  timing: "Daily from 7:30 am to 11:00 am ",
  desc: "<p>The soft morning sun and crisp mountain air create the perfect backdrop for a serene riverside breakfast. Breathe in fresh coffee and warm bread while enjoying delectable local delicacies, homemade spreads, and made-to-order eggs on our open terrace, with peaceful river views setting the tone for the day ahead.</p>",
  topLeftImg: "/image/rishikesh-cuisine-start-1.webp",
  topRightImg: '/image/rishikesh-cuisine-start-2.webp',
  bottomImg: "/image/rishikesh-cuisine-start-3.webp",
}

const treatData = {
  leftImg: "/image/rishikesh-cuisine-treat-1.webp",
  rightImg: "/image/rishikesh-cuisine-treat-2.webp",
  title: "For a little treat between meals",
  desc: `<p><label>From 12:00 pm to 2:00 pm,</label> you can enjoy light, flavorful specialties from our gourmet menu to keep you energized. If you are returning from a trek or a visit to the Ghats in the afternoon, a selection of fresh cakes and light snacks awaits you from <label> from 2:30 pm onwards.</label> Start your afternoon with refreshing juices and drinks in our lounge, served throughout the day to keep you hydrated and relaxed.</p>`
}

const diningData = {
  title: "Evening Gourmet Dining at De Coração ",
  timing: "Daily from 6:30 pm onwards ",
  desc: `<p>After a day of exploration and spiritual discovery, unwind with a relaxed dinner at our open-air dining area. Savor a specially crafted multi-course menu featuring regional favorites and global classics, all prepared with a focus on balance and flavor. End your evening with a warm drink by the fireplace, soaking in the quiet, starlit beauty of the Rishikesh night.</p>`,
  topLeftImg: "/image/rishikesh-cuisine-dining-1.webp",
  topRightImg: '/image/rishikesh-cuisine-dining-2.webp',
  bottomImg: "/image/rishikesh-cuisine-dining-3.webp",
}

const freshData = [
  {
    img: "/image/cuisine-fresh-1.webp",
    title: "Fresh Sourcing",
    desc: "Locally sourced produce for authentic flavors."
  },
  {
    img: "/image/cuisine-fresh-2.webp",
    title: "Gourmet Dining",
    desc: "Carefully crafted multi-course culinary experiences."
  },
  {
    img: "/image/cuisine-fresh-3.webp",
    title: "Diverse Cuisine",
    desc: "Variety of regional and international flavors."
  },
  {
    img: "/image/cuisine-fresh-4.webp",
    title: "Cozy Ambience",
    desc: "Warm and relaxing dining atmosphere."
  }
];


const signData = {
  leftImg: "/image/rishikesh-cuisine-sign-1.webp",
  rightImg: "/image/rishikesh-cuisine-sign-2.webp",
  title: "Signature Dinner Experience",
  desc: `<p>Turn every celebration into a memorable experience with a Specially Curated Dinner at De Coração. Enjoy refined flavors, carefully prepared dishes, and an inviting range of culinary options, thoughtfully created to cater to every palate.</p>
  <p>Dine in a welcoming and elegant setting designed to make every moment more special, whether you are relaxing over a meal, connecting with loved ones, or enjoying quality time with family and friends.</p>`
}

export default function CuisineRishikesh() {
  return (
    <>     
      <ImageHeader imageHead={imageHead} />
      <ContactHead quoteHead={quoteHead} />
      <CuisineStart data={startData} headingTag="h1"/>
      <CuisineTreat data={treatData} headingTag="h2"/>
      <CuisineStart data={diningData} headingTag="h3"/>
      <CuisineFresh freshData={freshData} />
      <CuisineTreat data={signData} headingTag="h4"/>
    </>
  )
}
